// One conversation. One Producer. One destination.
// Any CTA anywhere on the site can request the hero conversation on "/",
// optionally pre-filling the input with a starting sentence.

const KEY = "bnm.conversation.request";

// Human sentences for each service. Clicking a service chip or card starts
// the conversation with this line already written, ready to edit.
export const SERVICE_PREFILL = {
  "Brand Campaigns": "I want to create a Brand Campaign.",
  "Advertising": "I want to create an advertising campaign.",
  "Brand Films": "I want to create a Brand Film.",
  "Product Films": "I want to produce a Product Film.",
  "Fashion": "I want to produce a fashion campaign.",
  "Music Videos": "I want to produce a Music Video.",
  "Influencer Campaigns": "I want to create an Influencer Campaign.",
  "Offline Campaigns": "I want to create an Offline Campaign.",
  "Corporate Films": "I want to produce a Corporate Film.",
  "Testimonials": "I want to produce a Testimonial film.",
  "Events": "I want to produce an Event.",
  "Product Shoots": "I want to produce a Product Shoot.",
  "Social Media Content": "I want to create Social Media Content.",
  "Documentary": "I want to create a Documentary.",
  "Real Estate": "I want to produce a Real Estate film.",
  "AI Films": "I want to create an AI Film.",
};

export function serviceSentence(name) {
  return SERVICE_PREFILL[name] || `I want to create ${name}.`;
}

export function requestConversation(text = "") {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ text }));
  } catch {
    // storage unavailable (private mode); request is dropped
  }
}

export function consumeConversationRequest() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    sessionStorage.removeItem(KEY);
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
